const contactUs = {
  formTitle: 'Contact us',
  submit: 'Send',
  mail: 'E-Mail',
  name: 'Name',
  comment: 'Nachricht',
  sendText: 'Vielen danke fur kontaktiert uns!',
  toForm: 'Zurück'
}
export default contactUs;